import { isEqual } from "lodash";

export const isObject = (k: unknown): boolean =>
  (k !== null && typeof k === "object") || typeof k === "function";
export const hasKeys = (k: unknown): boolean =>
  (isObject(k) && !!Object.keys(k as object).length) || false;
export const filterEmptyObj = <T>(k: T): T | undefined =>
  hasKeys(k) ? k : undefined;

export const filterObjectByKeys = <T extends object, K extends keyof T>(
  obj: T,
  keys: string[],
): Partial<T> => {
  const keysSet = new Set(keys);
  return Object.keys(obj)
    .filter(key => keysSet.has(key))
    .reduce((acc, key) => {
      acc[key as K] = obj[key as K];

      return acc;
    }, {} as Partial<T>);
};

export const areObjectKeysEqual = (obj1: object, obj2: object): boolean =>
  isEqual(Object.keys(obj1).sort(), Object.keys(obj2).sort());

export const createNestedObject = <T extends string | number>(
  path: string,
  value: T,
): Record<string, unknown> => {
  const keys = path.split(".");
  const result: Record<string, any> = {};
  let current = result;

  keys.forEach((key, index) => {
    if (index === keys.length - 1) {
      current[key] = value;
    } else {
      current[key] = {};
      current = current[key];
    }
  });

  return result;
};
